module.exports = __webpack_public_path__ + "static/media/recipes_dashboard.61091aaf.jpeg";